import * as React from 'react';
import { BreadcrumbList } from '@grandvisionhq/analytics';

const Breadcrumbs = ({ pages  })=>{
    if (!pages) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "breadcrumbs"
    }, pages.map((page, index)=>index + 1 < pages.length ? /*#__PURE__*/ React.createElement("span", {
            key: page.name,
            className: "breadcrumbs__link-wrapper"
        }, /*#__PURE__*/ React.createElement("a", {
            href: page.url,
            className: "breadcrumbs__link"
        }, page.name)) : /*#__PURE__*/ React.createElement("span", {
            key: page.name,
            className: "breadcrumbs__current-page-text"
        }, page.name)
    ), /*#__PURE__*/ React.createElement(BreadcrumbList, {
        breadcrumbs: pages.slice(0, -1)
    }));
};
var Breadcrumbs$1 = Breadcrumbs;

export { Breadcrumbs$1 as default };
//# sourceMappingURL=Breadcrumbs.js.map
